module.exports = __webpack_public_path__ + "img/Cedar&Elm 1440x480.8d4155a9.png";